import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete'
import SaveIcon from '@mui/icons-material/Save';
import { stringUtils, OBRA_DIARIO_CONDICAO_CLIMATICA } from '../../../utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { uploadFile } from '_services'
import { useConfirm } from 'material-ui-confirm'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  Backdrop,
  Button,
  Card,
  CardActions,
  CardHeader,
  CardContent,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Fab,
  Grid,
  Input,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip
} from '@mui/material'
import { styled } from '@mui/material/styles';
import {
  obraDiarioAction
} from '../../../_actions'
import {
  ValidatorForm,
  TextValidator,
  SelectValidator
} from 'react-material-ui-form-validator'
import { UsuarioResponsavelAddModal } from './usuarioResponsavelAddModal.component';

const CustomInput = styled("input")`
  display: none;
`;

const CustomTypography = styled(Typography)(() => ({
  marginTop: 4,
  alignItems: 'center',
  color: '#666666',
  marginRight: 20,
  fontSize: 11
}));

const CustomDeleteIcon = styled(DeleteIcon)(() => ({
  color: '#4f4f4f',
  marginTop: 47,
  fontSize: 21,
  '&:hover': {
    cursor: 'pointer'
  },
}));

export const ObraDiarioAddModal = ({ modal, toggle, props, idObra }) => {

  const dispatch = useDispatch()
  const currentDate = moment().format("yyyy-MM-DD");
  const confirm = useConfirm()

  const [filesUploaded, setFilesUploaded] = useState([]);
  const [responsibleRegistereds, setResponsibleRegistereds] = useState([]);
  const [openFile, setOpenFile] = useState(false);
  const { classes, className, ...rest } = props
  const { match: { params } } = props;
  const formRef = React.createRef(null);

  const [modalAddUsuario, setModalAddUsuario] = useState(false);
  const toggleModalAddUsuario = () => setModalAddUsuario(!modalAddUsuario);

  const user = useSelector((state) => state.authentication.user)

  useEffect(() => {
    dispatch(obraDiarioAction.clear());
  }, [])

  const handleClose = () => {
    toggle();
  }

  const handleChange = (prop) => (event) => {
    dispatch(obraDiarioAction.onChangeProps(prop, event))
  }

  const handleOpenModalAddUsuario = () => {
    toggleModalAddUsuario();
  }

  function InsertText() {
    return (
      <Typography variant="h5">
        <b>Enviar Diário de Obra</b>
      </Typography>
    )
  }

  function SegHeader() {
    return <InsertText />
  }

  const handleSubmit = (event) => {

    let payload = {
      //se não for informado data, pega a data atual
      data: props.obraDiario.data ? moment(props.obraDiario.data).toISOString() : currentDate,
      condicaoClimatica: props.obraDiario.condicaoClimatica,
      idObra: parseInt(idObra),
      //pega a empresa do usuário logado
      idEmpresa: user?.usuariosEmpresas[0].idEmpresa,
      observacoes: props.obraDiario.observacoes,
      responsavelTecnico: props.obraDiario.responsavelTecnico,
      obrasDiariosAnexos: filesUploaded,
      obrasDiariosEquipes: responsibleRegistereds
    }

    dispatch(obraDiarioAction.createObraDiario(payload))
    toggle();
  };

  useEffect(() => {
    console.log('responsibleRegistereds', responsibleRegistereds)
  }, [responsibleRegistereds])

  const handleUploadClickFiles = (event) => {
    const files = Array.from(event.target.files); // Transformando em array para iteração

    setOpenFile(true);

    // Array para armazenar as promessas de upload
    const uploadPromises = files.map((file) =>
      uploadFile(file)
        .then((response) => {
          return { caminhoAnexo: response.toString() };
        })
        .catch((err) => {
          console.log(err);
          return null;
        })
    );

    // Esperar que todos os uploads sejam concluídos
    Promise.all(uploadPromises)
      .then((uploadedFiles) => {
        // Filtrar arquivos que tiveram sucesso no upload (não são null)
        const successfulUploads = uploadedFiles.filter((file) => file !== null);
        setFilesUploaded([...filesUploaded, ...successfulUploads]);
        setOpenFile(false);
      })
      .catch((err) => {
        console.log(err);
        setOpenFile(false);
      });
  };

  const handleRemoveOnListFile = caminhoAnexo => {
    confirm({
      title: 'Você deseja excluir este arquivo?',
      description: 'Essa operação removerá o arquivo deste diário de obra',
      disabled: props.obraDiario.isLoading,
      confirmationText: props.obraDiario.isLoading ? 'Excluindo arquivo...' : 'Sim, excluir!',
      cancellationText: 'Não!'
    }).then(() => {
      setFilesUploaded(filesUploaded.filter(ts => ts.caminhoAnexo != caminhoAnexo));
    })
  };

  const handleRemoveOnListUser = nome => {
    confirm({
      title: 'Você deseja excluir este responsável?',
      description: 'Essa operação removerá o responsável deste diário de obra',
      disabled: props.obraDiario.isLoading,
      confirmationText: props.obraDiario.isLoading ? 'Excluindo responsável...' : 'Sim, excluir!',
      cancellationText: 'Não!'
    }).then(() => {
      setResponsibleRegistereds(responsibleRegistereds.filter(ts => ts.nome != nome));
    })
  };

  return (
    <Dialog
      open={modal}
      fullWidth
      style={{ padding: 0, margin: 0 }}
      maxWidth='lg'
      onClose={toggle}
    >
      <DialogTitle align="right" style={{ paddingTop: 0, marginTop: 0, marginBottom: 0, paddingBottom: 0 }}>
        <Button
          variant="contained"
          style={{ backgroundColor: '#000', position: 'relative', marginTop: 15 }}
          onClick={() => handleClose()}>
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent style={{ padding: 0, margin: 0 }}>
        <Card style={{ marginTop: 0 }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <CardHeader
              style={{ marginTop: 0, paddingTop: 0 }}
              subheader="Cadastros"
              title={<SegHeader />}
            />
          </div>
          <Divider />
          <CardContent>
            <ValidatorForm
              className={classes.form}
              ref={formRef}
              id="formDiarioObra"
              onSubmit={handleSubmit}
            >
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} xl={6} xs={12}>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    type="date"
                    id="data"
                    label="Data *"
                    margin="normal"
                    onChange={handleChange('data')}
                    value={props.obraDiario.data ? moment(props.obraDiario.data).format("yyyy-MM-DD") : currentDate}
                    variant="outlined"
                    validators={['required']}
                    InputLabelProps={{
                      shrink: true
                    }}
                    errorMessages={['Campo obrigatório!']}
                  />
                </Grid>
                <Grid item lg={6} md={6} xl={6} xs={12}>
                  <SelectValidator
                    variant="outlined"
                    id="desonerado"
                    style={{ marginTop: 15 }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={props.obraDiario.condicaoClimatica}
                    onChange={handleChange('condicaoClimatica') || false}
                    label="Condição Climática *"
                    fullWidth
                    labelId="condicaoClimatica"
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                      <em>Condição Climática</em>
                    </MenuItem>
                    <MenuItem value={OBRA_DIARIO_CONDICAO_CLIMATICA.CHUVA}>CHUVA</MenuItem>
                    <MenuItem value={OBRA_DIARIO_CONDICAO_CLIMATICA.NUBLADO}>NUBLADO</MenuItem>
                    <MenuItem value={OBRA_DIARIO_CONDICAO_CLIMATICA.SOL}>SOL</MenuItem>
                  </SelectValidator>
                </Grid>
                <Grid item lg={6} md={6} xl={6} xs={12}>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    multiline
                    minRows={2}
                    InputLabelProps={{
                      shrink: true
                    }}
                    id="observacoes"
                    label="Observações"
                    margin="normal"
                    onInput={stringUtils.toInputUppercase}
                    onChange={handleChange('observacoes')}
                    value={props.obraDiario.observacoes || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid item lg={6} md={6} xs={12} align="left">
                  {responsibleRegistereds && responsibleRegistereds.length > 0 &&
                    <Table size="small" fullWidth>
                      <TableHead>
                        <TableRow key={0}>
                          <TableCell colSpan={3} align="center">
                            Responsável(is)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableHead>
                        <TableRow key={0}>
                          <TableCell>
                            Nome
                          </TableCell>
                          <TableCell>
                            Cargo
                          </TableCell>
                          <TableCell>
                            Ação
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {responsibleRegistereds.map((item) => (
                        <TableBody>
                          <TableRow key={item.nome}>
                            <TableCell align="left" style={{ fontSize: 10, verticalAlign: 'middle' }}>
                              <span>{item.usuario}</span>
                            </TableCell>
                            <TableCell align="left" style={{ fontSize: 10, verticalAlign: 'middle' }}>
                              <span>{item.cargo}</span>
                            </TableCell>
                            <TableCell align="left" style={{ fontSize: 10, verticalAlign: 'middle' }}>
                              <CustomDeleteIcon size="small" style={{ marginTop: 0, marginLeft: 4 }} onClick={() => handleRemoveOnListUser(item.nome)} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ))}
                    </Table>
                  }
                </Grid>
                <Grid item lg={6} md={6} xl={6} xs={12}>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    id="responsavelTecnico"
                    label="Responsável Técnico *"
                    margin="normal"
                    validators={['required']}
                    InputLabelProps={{
                      shrink: true
                    }}
                    errorMessages={['Campo obrigatório!']}
                    onInput={stringUtils.toInputUppercase}
                    onChange={handleChange('responsavelTecnico')}
                    value={props.obraDiario.responsavelTecnico || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid item lg={6} md={6} xl={6} xs={12} align="center" style={{ marginTop: 10 }}>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openFile}>
                      <Grid
                        container
                        spacing={3}
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        alignContent="center"
                        wrap="nowrap"
                      >
                        <Grid item>
                          <CircularProgress color="primary" />
                        </Grid>
                        <Grid item>
                          <Typography variant="h6" color="textPrimary">
                            Enviando arquivo(s)...
                          </Typography>
                        </Grid>
                      </Grid>
                    </Backdrop>
                    <CustomTypography variant="body2" align="center">
                      Enviar arquivos
                    </CustomTypography>
                    <CustomInput
                      accept="files/*"
                      id="file"
                      type="file"
                      multiple
                      onChange={(e) => handleUploadClickFiles(e)}
                    />
                    <label htmlFor="file">
                      <Tooltip title="Enviar arquivos">
                        <Fab component="span" style={{ justifyContent: 'center' }}>
                          <AttachFileIcon />
                        </Fab>
                      </Tooltip>
                    </label>
                  </Grid>
                  <Grid item lg={6} md={6} xs={12} align="left">
                    {filesUploaded && filesUploaded.length > 0 &&
                      <Table size="small" fullWidth>
                        <TableHead>
                          <TableRow key={0}>
                            <TableCell>
                              Anexo(s)
                            </TableCell>
                            <TableCell>
                              &nbsp;
                            </TableCell>
                            <TableCell>
                              Ação
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {filesUploaded.map((item) => (
                          <TableBody>
                            <TableRow key={item.caminhoAnexo}>
                              <TableCell align="left" colSpan={2} style={{ fontSize: 10, verticalAlign: 'middle' }}>
                                <span>{item.caminhoAnexo}</span>
                              </TableCell>
                              <TableCell align="left" style={{ fontSize: 10, verticalAlign: 'middle' }}>
                                <CustomDeleteIcon size="small" style={{ marginTop: 0, marginLeft: 4 }} onClick={() => handleRemoveOnListFile(item.caminhoAnexo)} />
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        ))}
                      </Table>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <CardActions>
                <Grid container style={{
                  display: 'flex',
                  alignItems: 'end',
                  flexDirection: 'row',
                  textAlign: 'end',
                  justifyContent: 'end'
                }}>
                  <Button
                    variant="outlined"
                    style={{ color: '#000', borderColor: '#000' }}
                    onClick={toggle}
                  >
                    Cancelar
                  </Button>
                  <Button style={{ backgroundColor: '#000' }}
                    name="btnUsuarios"
                    id="btnUsuarios"
                    className="btn"
                    variant="contained"
                    component='a'
                    onClick={() => handleOpenModalAddUsuario()}>Cadastrar responsável&nbsp;<FontAwesomeIcon icon={faUserPlus} />
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{ backgroundColor: '#000' }}
                    disabled={props.obraDiario.isLoading}
                    startIcon={<SaveIcon />}
                    endIcon={props.obraDiario.isLoading && <CircularProgress size={24} />}
                  >
                    {props.obraDiario.isLoading ? 'Salvando diário...' : 'Salvar'}
                  </Button>
                </Grid>
              </CardActions>
            </ValidatorForm>
          </CardContent>
        </Card>
      </DialogContent>

      {
        (modalAddUsuario ?
          <UsuarioResponsavelAddModal toggle={toggleModalAddUsuario} modal={modalAddUsuario} props={props} setResponsibleRegistereds={setResponsibleRegistereds} />
          :
          null
        )
      }
    </Dialog >
  )
}
